/**
 * Simple resource acquisition state manager. This is not a real semaphore,
 * but it's conceptually similar except for the one key difference (not counting
 * the fact that it's not atomic and only works for cooperative concurrency
 * and not real parallelism, e.g., Web Workers): it does not provide a way
 * to wait on a resource, but it allows to query the resource state instead.
 */
class SemaphoreLike {
  private count = 0;

  /**
   * Increment resource usage counter.
   */
  public acquire(): void {
    this.count++;
  }

  /**
   * Decrement resource usage counter.
   */
  public release(): void {
    if (this.count === 0) {
      throw new Error('Release without acquire');
    }
    this.count--;
  }

  /**
   * Checks the resource usage counter.
   *
   * @returns true if the resource is locked or false if the resource is free.
   */
  public isAcquired(): boolean {
    return this.count > 0;
  }
}

export default SemaphoreLike;
